// import React, { useLayoutEffect, useRef } from 'react';
// import * as am4core from '@amcharts/amcharts4/core';
// import * as am4charts from '@amcharts/amcharts4/charts';
// import am4themes_animated from '@amcharts/amcharts4/themes/animated';

// am4core.useTheme(am4themes_animated);

// const WorkingStatus = ({ chart_data }) => {
//   const chartRef = useRef(null);

//   useLayoutEffect(() => {
//     if (chartRef.current) {
//       chartRef.current.dispose();
//     }

//     let chart = am4core.create('working-status', am4charts.XYChart3D);
//     chartRef.current = chart;

//     chart.logo.disabled = true;
//     chart.paddingBottom = 30;
   
//     chart.data = chart_data;
   
//     let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
//     categoryAxis.dataFields.category = 'Year';
//     categoryAxis.renderer.grid.template.location = 0;
//     categoryAxis.renderer.minGridDistance = 30;
    
//     categoryAxis.numberFormatter.numberFormat = '#';
    
//     let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
//     valueAxis.min = 0;
//     valueAxis.max = 100;
    
//     valueAxis.renderer.grid.template.disabled = true;

    
//     valueAxis.renderer.labels.template.disabled = true;
//     valueAxis.renderer.labels.template.fontSize = 12;  
    
//     const createSeries = (field, name, color) => {
//       let series = chart.series.push(new am4charts.ColumnSeries3D());
//       series.dataFields.valueY = field;
//       series.dataFields.categoryX = 'Year';
//       series.name = name;
//       series.stacked = true;
//       series.columns.template.tooltipText = `[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}%`;
//       series.columns.template.fill = color;
//       series.columns.template.stroke = color;     

//       let labelBullet = series.bullets.push(new am4charts.LabelBullet());
//       labelBullet.label.text = '{valueY}%';
//       labelBullet.label.fill = am4core.color('#ffffff');
//       labelBullet.label.fontSize = 12;  
//       labelBullet.locationY = 0.5; 

//       return series;
//     };

//     createSeries('Work(Full-time)', 'Work (Full-time)', am4core.color('#0000FF'));
//     createSeries('Work(Part-time)', 'Work (Part-time)', am4core.color('#FF69B4'));
//     createSeries('Student(Full-time)', 'Student (Full-time)', am4core.color('#FFD700'));
//     createSeries('Student(Part-time)', 'Student (Part-time)', am4core.color('#008000'));
//     createSeries('Scholar', 'Scholar', am4core.color('#FF4500'));
//     createSeries('Pensioner', 'Pensioner', am4core.color('#8A2BE2'));
//     createSeries('Unemployed', 'Unemployed', am4core.color('#D2691E'));
//     createSeries('Housewife/Househusband', 'Housewife/Househusband', am4core.color('#FF7F50'));

//     chart.legend = new am4charts.Legend();

//     return () => {
//       if (chartRef.current) {
//         chartRef.current.dispose();
//         chartRef.current = null;
//       }
//     };
//   }, [chart_data]);

//   return <div id="working-status" style={{ width: '100%', height: '500px' }}></div>;
// };

// export default WorkingStatus;


import React, { useLayoutEffect, useRef } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

am4core.useTheme(am4themes_animated);

const processData = (data) => {
  return data.map(item => ({
    ...item,
    Year: item.Year.toString().replace('.0', '')
  }));
};

const WorkingStatus = ({ chart_data }) => {
  const chartRef = useRef(null);
  const processedData = processData(chart_data);

  useLayoutEffect(() => {
    if (chartRef.current) {
      chartRef.current.dispose();
    }

    let chart = am4core.create('working-status', am4charts.XYChart3D);
    chartRef.current = chart;

    chart.logo.disabled = true;
    chart.paddingBottom = 30;
   
    chart.data = processedData;
   
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'Year';
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 30;
    
    categoryAxis.numberFormatter.numberFormat = '#';
    
    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.max = 100;
    
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.labels.template.disabled = true;
    valueAxis.renderer.labels.template.fontSize = 12;  
    
    const createSeries = (field, name, color) => {
      let series = chart.series.push(new am4charts.ColumnSeries3D());
      series.dataFields.valueY = field;
      series.dataFields.categoryX = 'Year';
      series.name = name;
      series.stacked = true;
      series.columns.template.tooltipText = `[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}%`;
      series.columns.template.fill = color;
      series.columns.template.stroke = color;     

      let labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.text = '{valueY}%';
      labelBullet.label.fill = am4core.color('#ffffff');
      labelBullet.label.fontSize = 12;  
      labelBullet.locationY = 0.5; 

      return series;
    };

    createSeries('work(full-time)', 'Work (Full-time)', am4core.color('#0000FF'));
    createSeries('work(part-time)', 'Work (Part-time)', am4core.color('#FF69B4'));
    createSeries('student(full-time)', 'Student (Full-time)', am4core.color('#FFD700'));
    createSeries('student(part-time)', 'Student (Part-time)', am4core.color('#008000'));
    createSeries('scholar', 'Scholar', am4core.color('#FF4500'));
    createSeries('pensioner', 'Pensioner', am4core.color('#8A2BE2'));
    createSeries('unemployed', 'Unemployed', am4core.color('#D2691E'));
    createSeries('housewife/househusband', 'Housewife/Househusband', am4core.color('#FF7F50'));

    chart.legend = new am4charts.Legend();

    return () => {
      if (chartRef.current) {
        chartRef.current.dispose();
        chartRef.current = null;
      }
    };
  }, [processedData]);

  return <div id="working-status" style={{ width: "100%", height: "500px" }}></div>;
};

export default WorkingStatus;